<template>
  <v-container max-width="900px" class="pt-4">
    <div class="text-center mb-6">
      <h1 class="mb-0"><span>📍</span>{{ $t('rollOffWizard.map.title') }}</h1>
      <p class="mb-0">{{ $t('rollOffWizard.map.subtitle') }}</p>
    </div>
    <v-row justify="center">
      <v-col cols="12" md="7" lg="5">
        <div class="mb-0" style="font-size:1.08rem;"><strong>{{ $t('rollOffWizard.map.location') }}</strong></div>
        <div class="mb-2" style="color:#222;">{{ userStore.form.address }}</div>
        <div class="mb-2 mt-4" style="font-size:1.08rem;"><strong>{{ $t('rollOffWizard.map.movePin') }}</strong></div>
        <div class="map-rounded-lg">
        <gmap-map
          class="pa-0 ma-0 w-100"
          :center="mapCenter"
          :zoom="18"
          map-type-id="satellite"
          :options="{ disableDefaultUI: true }"
          style="width: 100%; height: 300px"
          @tilesloaded="indexStore.loading = false"
        >
          <gmap-marker
            :position="dropOffLocation"
            :draggable="true"
            @dragend="updateLocation"
          />
        </gmap-map>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRollOffWizardStore } from '@/store/rollOffWizard'
import { useUserStore } from '@/store/user'
import { useIndexStore } from '@/store/index'

const wizardStore = useRollOffWizardStore()
const userStore = useUserStore()
const indexStore = useIndexStore()

// Make sure it's loading when created otherwise user might go next before map loads and cause error
indexStore.loading = true;

const defaultLocation = {
  lat: (userStore.form.lat && !isNaN(Number(userStore.form.lat))) ? Number(userStore.form.lat) : 24.5551,
  lng: (userStore.form.lng && !isNaN(Number(userStore.form.lng))) ? Number(userStore.form.lng) : -81.7800
}
const dropOffLocation = ref({ ...defaultLocation })

const mapCenter = computed(() => dropOffLocation.value)

// When the marker is dragged, update the local marker and store the URL in the store
function updateLocation(event) {
  // The event object contains the marker, get position from marker
  const position = event.latLng || event.position;
  const lat = position.lat();
  const lng = position.lng();
  
  dropOffLocation.value = { lat, lng };
  wizardStore.setMapLocation({ lat, lng });
}

onMounted(() => {
  if (!wizardStore.mapLocation) {
    const { lat, lng } = dropOffLocation.value;
    wizardStore.setMapLocation({ lat: Number(lat), lng: Number(lng) });
  }
});
</script>
<style scoped>
.map-rounded-lg {
  border-radius: 16px;
  overflow: hidden;
}
.map-rounded-lg .vue-map-container,
.map-rounded-lg .gm-style,
.map-rounded-lg div {
  border-radius: 16px !important;
}
</style>